import * as React from 'react'
import { faChevronRightSolid, FaIcon } from '@/lib/fa'
import { GroupModel } from '@/app/models/groupModel'

type Props = {
  group: GroupModel
  icon: any
  setSelectedGroup: (group) => void
}

const EditGroupListItem = ({ group, icon, setSelectedGroup }: Props) => {
  return (
    <div
      onClick={() => setSelectedGroup(group)}
      className="tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-4 tw-border-t tw-border-base-300 tw-px-2 tw-py-4 hover:tw-bg-gray-100"
    >
      <div
        className={`tw-text-medium tw-flex tw-items-center tw-gap-2 tw-text-content-base`}
      >
        <FaIcon
          icon={icon}
          className="tw-color-content-base tw-h-4 tw-w-4 tw-cursor-pointer"
        />
        <p>{group.name}</p>
      </div>
      <FaIcon icon={faChevronRightSolid} className="tw-z-5 tw-h-5" />
    </div>
  )
}

export default EditGroupListItem
